export const audienceListStyles = {
  likesText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '136%',
    color: '#23252F',
    margin: '24px 0 0 24px',
  },
  membersText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '146%',
    color: '#6E707A',
    margin: '0 0 4px 24px',
  },
  divider: { background: '#F3F4F9', height: '2px', border: 'none' },
  infiniteScroll: {
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      border: 'none',
      height: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
    margin: '0 0 20px 24px',
    height: '430px',
  },
  membersContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '4px 0',
    gap: '12px',
    height: '60px',
  },
  userAvatar: {
    width: '36px',
    height: '36px',
    borderRadius: '4px',
  },
  userName: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '146%',
    color: '#23252F',
  },
  circularProgress: {
    position: 'absolute',
    left: '0',
    right: '0',
    top: '0',
    bottom: '0',
    margin: 'auto',
  },
  scrollContainer: {
    overflow: 'auto',
    padding: '0 40px',
    width: '100%',
    maxHeight: '477px',
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      border: 'none',
      height: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },
  audienceContainer: {
    width: 'calc(100% - 5px)',
    padding: '16px 40px',
  },
  loaderContainer: { width: '100%', display: 'flex', justifyContent: 'center', padding: '20px' },
};
